export default __webpack_public_path__ + "static/media/header-back.4e792c6e.jpg";